// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/routeParamsCache.js#1 $
'use strict';

/**
* @ngdoc service
* @name tcApp.RouteParamsCache
* @description
* Route Parameters Cache maintains state of the component between page navigation events.
*
*/
angular.module('tcApp')
  .factory('RouteParamsCache', function($cacheFactory, $rootScope) {
	var routeParamsCache = $cacheFactory('routeParamsCache');

	var oldPut = routeParamsCache.put;
	routeParamsCache.put = function(key, value) {
		// TSKIPBANNER should never be cached, as there's no reason to skip the banner when returning to the page from elsewhere
		if (angular.isObject(value)) delete value.TSKIPBANNER;

		oldPut(key, value);
	};

	/* eslint-disable angular/on-watch */
	$rootScope.$on('tcMenu:MainMenuSelected',function() {
		routeParamsCache.removeAll();
	});

	return routeParamsCache;
});
